// ==========================================================================
// Lightbox video
// ==========================================================================
/* jshint esnext: true */
import { APP_NAME, $html, $document } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'LightboxVideo';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor (options) {
        super(options);
    }

    init() {
        this.$el.on(EVENT.CLICK, '.js-lightboxVideo-close', (event) => this.closeLightbox());
        $document.on(EVENT.CLICK, '.js-lightboxVideo-open', (event) => this.openLightbox(event));
    }

    // Open lightbox
    // ==========================================================================
    openLightbox(event) {
        const $target = $(event.currentTarget);
        const id = $target.data('video');
        const provider = $target.data('video-provider');
        let url;

        switch(provider) {
            case 'youtube':
                url = 'https://www.youtube.com/embed/';
                break;

            case 'vimeo':
                url = 'https://player.vimeo.com/video/';
                break;
        }

        $html.addClass('has-lightbox-open');
        this.$el.find('.js-lightboxVideo-container').html('<iframe src="'+ url + id +'?autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
    }

    // Close lightbox
    // ==========================================================================
    closeLightbox() {
        $html.removeClass('has-lightbox-open');

        setTimeout(() => {
            this.$el.find('.js-lightboxVideo-container').html('');
        }, 300);
    }

    // Destroy
    // ==========================================================================
    destroy() {
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
